import { ADD_SEARCH_TERM } from '../constants/action-types';

const initState = {
  searchTerm: ''
}

const searchReducer = (state = initState, action) => {
  switch (action.type) {
    case ADD_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.searchInput
      }

    default:
      return state
  }
}

export default searchReducer;